import { useMemo, useState } from 'react'

import {
  Alert,
  Col,
  Form,
  OverlayTrigger,
  Row,
  Table,
  Tooltip,
} from 'react-bootstrap'

import {
  ArrowClockwise,
  BuildingDown,
  Check2Square,
  CheckCircleFill,
  HandIndexFill,
} from 'react-bootstrap-icons'
import { toast } from 'react-toastify'

import { CustomButton } from '../../../../../components/CustomButton'
import { Ghost } from '../../../../../components/Ghost'

import WmsInventarioService from '../../../../../services/database/WmsInventarioService'

import { sendErrorApiMessage } from '../../../../../utils/sendErrorApiMessage'

import { useOrdenation } from '../../../../../hooks/useOrdenation'

import { ComponentContainer, ComponentContent } from '../../styles'

import { getValue } from '../../../../../utils/getValue'
import { Ask } from '../../../../Ask'
import { ModalProdutos } from '../../../../ModalProdutos'
import { LoaderWMS } from '../../components/LoaderWMS'
import { Label, Labels, Square, Text } from './styles'

export function Products({ inventory, setInventory, onNext }) {
  const [selectedProducts, setSelectedProducts] = useState([])
  const [addresses, setAddresses] = useState([])
  const [isAddressesLoading, setIsAddressesLoading] = useState(false)
  const [selectedAddresses, setSelectedAddresses] = useState([])

  const [address, setAddress] = useState({
    deposito: '',
    rua: { from: '', to: '' },
    predio: { from: '', to: '' },
    nivel: { from: '', to: '' },
    apto: { from: '', to: '' },
    tipoender: '',
    lado: '',
  })

  const [filterBy, setFilterBy] = useState('')
  const [isModalProdutosOpen, setIsModalProdutosOpen] = useState(false)

  const totalAptos = addresses.filter(
    (address) =>
      !address.qtpendentrada && !address.qtpendsaida && !address.qtbloqueada,
  )

  const totalPendentes = addresses.filter(
    (address) => address.qtpendentrada || address.qtpendsaida,
  )

  const totalBloqueados = addresses.filter((address) => address.qtbloqueada)

  const totalNaoEnderecados = addresses.filter(
    (address) => !address.codendereco,
  )

  const totalImpedimentos = addresses.filter(
    (address) =>
      address.qtpendentrada || address.qtpendsaida || address.qtbloqueada,
  )

  const filteredAddressesByStatus = useMemo(() => {
    let data = addresses

    if (filterBy == 'aptos') {
      data = data.filter(
        (address) =>
          !address.qtpendentrada &&
          !address.qtpendsaida &&
          !address.qtbloqueada,
      )
    }

    if (filterBy == 'pendente') {
      data = data.filter(
        (address) => address.qtpendentrada || address.qtpendsaida,
      )
    }

    if (filterBy == 'bloqueada') {
      data = data.filter((address) => address.qtbloqueada)
    }

    if (address.deposito) {
      data = data.filter((addr) => addr.deposito == address.deposito)
    }

    if (address.rua.from && address.rua.to) {
      data = data.filter(
        (addr) =>
          Number(addr.rua) >= Number(address.rua.from) &&
          Number(addr.rua) <= Number(address.rua.to),
      )
    }

    if (address.predio.from && address.predio.to) {
      data = data.filter(
        (addr) =>
          Number(addr.predio) >= Number(address.predio.from) &&
          Number(addr.predio) <= Number(address.predio.to),
      )
    }

    if (address.nivel.from && address.nivel.to) {
      data = data.filter(
        (addr) =>
          Number(addr.nivel) >= Number(address.nivel.from) &&
          Number(addr.nivel) <= Number(address.nivel.to),
      )
    }

    if (address.apto.from && address.apto.to) {
      data = data.filter(
        (addr) =>
          Number(addr.apto) >= Number(address.apto.from) &&
          Number(addr.apto) <= Number(address.apto.to),
      )
    }

    if (address.tipoender) {
      data = data.filter((addr) => addr.tipoender.includes(address.tipoender))
    }

    if (address.lado) {
      if (address.lado === 'par') {
        data = data.filter((addr) => Number(addr.predio) % 2 === 0)
      } else {
        data = data.filter((addr) => Number(addr.predio) % 2 !== 0)
      }
    }

    return data
  }, [
    address.deposito,
    address.apto.from,
    address.apto.to,
    address.nivel.from,
    address.nivel.to,
    address.predio.from,
    address.predio.to,
    address.rua.from,
    address.rua.to,
    address.tipoender,
    address.lado,
    addresses,
    filterBy,
  ])

  const {
    filteredItems: filteredAddresses,
    Th,
    Paginate,
    itemsPerPage,
    setItemsPerPage,
  } = useOrdenation(filteredAddressesByStatus, 'status', 'asc', 100)

  const conditions = {
    qualified: {
      color: '#399E5A',
      text: `Apto`,
      amount: `Apto (${totalAptos.length})`,
    },
    quantityPending: {
      color: '#F0A202',
      text: `Qtde. Pendente`,
      amount: `Qtde. Pendente (${totalPendentes.length})`,
    },
    quantityBlocked: {
      color: '#8C1C13',
      text: `Qtde. Bloqueada`,
      amount: `Qtde. Bloqueada (${totalBloqueados.length})`,
    },
    unaddressed: {
      color: '#93A8AC',
      text: `Não Endereçado`,
      amount: `Não Endereçado (${totalNaoEnderecados.length})`,
    },
  }

  function handleSelectProducts(products) {
    setSelectedProducts(products)
  }

  function handleConfirmAddresses() {
    setInventory((prevState) => ({
      ...prevState,
      addresses: selectedAddresses,
      isAddressesConfirmed: true,
    }))

    toast.info('Os endereços foram confirmados!')

    onNext()
  }

  function selectAllAddresses(data) {
    for (const address of data) {
      if (
        address.qtpendentrada ||
        address.qtpendsaida ||
        address.qtbloqueada ||
        !address.codendereco
      ) {
        continue
      } else {
        setSelectedAddresses((prevState) => {
          if (!prevState.includes(address)) {
            return [...prevState, address]
          }

          return prevState
        })
      }
    }
  }

  function getCondition(address, type) {
    switch (type) {
      case 'color': {
        if (address.qtpendentrada || address.qtpendsaida) {
          return conditions.quantityPending.color
        } else if (address.qtbloqueada) {
          return conditions.quantityBlocked.color
        } else if (!address.codendereco) {
          return conditions.unaddressed.color
        } else {
          return conditions.qualified.color
        }
      }

      case 'text': {
        if (address.qtpendentrada || address.qtpendsaida) {
          return conditions.quantityPending.text
        } else if (address.qtbloqueada) {
          return conditions.quantityBlocked.text
        } else if (!address.codendereco) {
          return conditions.unaddressed.text
        } else {
          return conditions.qualified.text
        }
      }

      case 'amount': {
        if (address.qtpendentrada || address.qtpendsaida) {
          return conditions.quantityPending.amount
        } else if (address.qtbloqueada) {
          return conditions.quantityBlocked.amount
        } else if (!address.codendereco) {
          return conditions.unaddressed.amount
        } else {
          return conditions.qualified.amount
        }
      }
    }
  }

  async function loadAddresses() {
    setSelectedAddresses([])

    try {
      setIsAddressesLoading(true)

      const data = await WmsInventarioService.getAddresses(
        selectedProducts.map((selectedProduct) => selectedProduct.SKU),
      )

      selectAllAddresses(data)
      setAddresses(data)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível buscar os endereços')
    } finally {
      setIsAddressesLoading(false)
    }
  }

  return (
    <>
      <ComponentContainer>
        <ComponentContent>
          <p>Selecione os produtos a serem inventariados.</p>

          <Ghost isVisible={!inventory.isConfigConfirmed}>
            <Alert variant="warning">
              Crie ou selecione um inventário na etapa anterior.
            </Alert>
          </Ghost>

          <Ghost isVisible={inventory.isConfigConfirmed}>
            <Row className="mb-3">
              <Col>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                  }}
                >
                  <CustomButton
                    title="Selec. Produtos"
                    onClick={() => setIsModalProdutosOpen(true)}
                  >
                    <HandIndexFill />
                  </CustomButton>

                  <CustomButton
                    title="Buscar Endereços"
                    onClick={() => loadAddresses(selectedProducts)}
                    isDisabled={selectedProducts.length === 0}
                    isLoading={isAddressesLoading}
                    isLoadingText="Buscando..."
                  >
                    <BuildingDown />
                  </CustomButton>
                </div>
              </Col>
            </Row>

            <Row className="mt-3">
              <Col xs={1}>
                <Form.Label>Depósito</Form.Label>
                <Form.Control
                  name="deposito"
                  value={address.deposito}
                  onChange={(e) =>
                    setAddress((prevState) => ({
                      ...prevState,
                      deposito: e.target.value,
                    }))
                  }
                />
              </Col>

              <Col xs={2}>
                <Form.Label>Rua</Form.Label>

                <div
                  style={{
                    display: 'flex',
                    gap: 10,
                  }}
                >
                  <Form.Control
                    value={address.rua.from}
                    placeholder="De"
                    onChange={(e) =>
                      setAddress((prevState) => ({
                        ...prevState,
                        rua: {
                          ...prevState.rua,
                          from: e.target.value,
                        },
                      }))
                    }
                  />

                  <Form.Control
                    value={address.rua.to}
                    placeholder="Até"
                    onChange={(e) =>
                      setAddress((prevState) => ({
                        ...prevState,
                        rua: {
                          ...prevState.rua,
                          to: e.target.value,
                        },
                      }))
                    }
                  />
                </div>
              </Col>

              <Col xs={2}>
                <Form.Label>Prédio</Form.Label>
                <div
                  style={{
                    display: 'flex',
                    gap: 10,
                  }}
                >
                  <Form.Control
                    placeholder="De"
                    value={address.predio.from}
                    onChange={(e) =>
                      setAddress((prevState) => ({
                        ...prevState,
                        predio: {
                          ...prevState.predio,
                          from: e.target.value,
                        },
                      }))
                    }
                  />

                  <Form.Control
                    placeholder="Até"
                    value={address.predio.to}
                    onChange={(e) =>
                      setAddress((prevState) => ({
                        ...prevState,
                        predio: {
                          ...prevState.predio,
                          to: e.target.value,
                        },
                      }))
                    }
                  />
                </div>
              </Col>

              <Col xs={2}>
                <Form.Label>Nível</Form.Label>
                <div
                  style={{
                    display: 'flex',
                    gap: 10,
                  }}
                >
                  <Form.Control
                    placeholder="De"
                    value={address.nivel.from}
                    onChange={(e) =>
                      setAddress((prevState) => ({
                        ...prevState,
                        nivel: {
                          ...prevState.nivel,
                          from: e.target.value,
                        },
                      }))
                    }
                  />

                  <Form.Control
                    placeholder="Até"
                    value={address.nivel.to}
                    onChange={(e) =>
                      setAddress((prevState) => ({
                        ...prevState,
                        nivel: {
                          ...prevState.nivel,
                          to: e.target.value,
                        },
                      }))
                    }
                  />
                </div>
              </Col>

              <Col xs={2}>
                <Form.Label>Ap</Form.Label>
                <div
                  style={{
                    display: 'flex',
                    gap: 10,
                  }}
                >
                  <Form.Control
                    placeholder="De"
                    value={address.apto.from}
                    onChange={(e) =>
                      setAddress((prevState) => ({
                        ...prevState,
                        apto: {
                          ...prevState.apto,
                          from: e.target.value,
                        },
                      }))
                    }
                  />

                  <Form.Control
                    placeholder="Até"
                    value={address.apto.to}
                    onChange={(e) =>
                      setAddress((prevState) => ({
                        ...prevState,
                        apto: {
                          ...prevState.apto,
                          to: e.target.value,
                        },
                      }))
                    }
                  />
                </div>
              </Col>

              <Col xs={1}>
                <Form.Label>Tipo End.</Form.Label>

                <Form.Select
                  value={address.tipoender}
                  onChange={(e) =>
                    setAddress((prevState) => ({
                      ...prevState,
                      tipoender: e.target.value,
                    }))
                  }
                >
                  <option value="">Todos</option>
                  <option value="AP">AP</option>
                  <option value="AE">AE</option>
                </Form.Select>
              </Col>

              <Col>
                <Form.Label>Lado</Form.Label>
                <Form.Select
                  value={address.lado}
                  onChange={(e) =>
                    setAddress((prevState) => ({
                      ...prevState,
                      lado: e.target.value,
                    }))
                  }
                >
                  <option value="">Todos</option>
                  <option value="par">Par</option>
                  <option value="impar">Ímpar</option>
                </Form.Select>
              </Col>
            </Row>

            <Row className="my-3">
              <Col
                xs={3}
                style={{
                  display: 'flex',
                  alignItems: 'flex-end',
                }}
              >
                <CustomButton
                  noMargin
                  title="Recarregar"
                  onClick={loadAddresses}
                  isLoading={isAddressesLoading}
                  isLoadingText="Recarregando..."
                >
                  <ArrowClockwise />
                </CustomButton>

                <CustomButton
                  title="Confirmar"
                  onClick={() =>
                    Ask(
                      `${selectedAddresses.length} endereços foram selecionados, deseja continuar?`,
                      () => handleConfirmAddresses(),
                    )
                  }
                  isDisabled={selectedAddresses.length === 0}
                >
                  <CheckCircleFill />
                </CustomButton>
              </Col>

              <Col xs={2}>
                <Form.Label>Filtrar por</Form.Label>
                <Form.Select
                  value={filterBy}
                  onChange={(e) => setFilterBy(e.target.value)}
                >
                  <option value="">Todos</option>
                  <option value="aptos">Aptos</option>
                  <option value="pendente">Qtde. Pendente</option>
                  <option value="bloqueada">Qtde. Bloqueada </option>
                </Form.Select>
              </Col>

              <Col xs={2}>
                <Form.Label>Endereços p/ página</Form.Label>
                <Form.Select
                  value={itemsPerPage}
                  onChange={(e) => setItemsPerPage(e.target.value)}
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </Form.Select>
              </Col>
            </Row>

            <LoaderWMS isLoading={isAddressesLoading}>
              {addresses.length > 0 && (
                <>
                  <div
                    className="mt-3"
                    style={{
                      width: '100%',
                      display: 'flex',
                      alignItems: 'flex-end',
                      justifyContent: 'flex-end',
                    }}
                  >
                    <strong>
                      Mostrando {filteredAddresses.length} de{' '}
                      {filteredAddressesByStatus.length} endereços
                    </strong>
                  </div>

                  <div
                    className="mt-3"
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <Labels>
                      <Label>
                        <Square color={conditions.qualified.color} />
                        <Text>{conditions.qualified.amount}</Text>
                      </Label>

                      <Label>
                        <Square color={conditions.quantityPending.color} />
                        <Text>{conditions.quantityPending.amount} </Text>
                      </Label>

                      <Label>
                        <Square color={conditions.quantityBlocked.color} />
                        <Text>{conditions.quantityBlocked.amount} </Text>
                      </Label>

                      <Label>
                        <Square color={conditions.unaddressed.color} />
                        <Text>{conditions.unaddressed.amount} </Text>
                      </Label>
                    </Labels>
                  </div>

                  <Table
                    bordered
                    striped
                    hover
                  >
                    <thead>
                      <tr>
                        <th
                          scope="row"
                          colSpan="12"
                        >
                          <section
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                            }}
                          >
                            <article>
                              <CustomButton
                                noMargin
                                title="Selecionar/Desmarcar Todos"
                                onClick={() => {
                                  if (selectedAddresses.length > 0) {
                                    setSelectedAddresses([])
                                  } else {
                                    selectAllAddresses(
                                      filteredAddressesByStatus,
                                    )
                                  }
                                }}
                              >
                                <Check2Square />
                              </CustomButton>
                            </article>

                            <strong>
                              {selectedAddresses.length} selecionados
                            </strong>

                            <article
                              style={{
                                display: 'flex',
                                gap: 20,
                              }}
                            >
                              <strong>Total: {addresses.length}</strong>
                              <strong>Aptos: {totalAptos.length}</strong>
                              <strong>
                                Impedidos: {totalImpedimentos.length}
                              </strong>
                            </article>
                          </section>
                        </th>
                      </tr>

                      <tr>
                        <th>
                          <Form.Check
                            checked={
                              filteredAddresses.length > 0 &&
                              filteredAddresses.every((address) =>
                                selectedAddresses.includes(address),
                              )
                            }
                            disabled={filteredAddresses.length === 0}
                            onChange={(e) => {
                              if (e.target.checked) {
                                selectAllAddresses(filteredAddresses)
                              } else {
                                for (const address of filteredAddresses) {
                                  setSelectedAddresses((prevState) =>
                                    prevState.filter(
                                      (addr) => addr !== address,
                                    ),
                                  )
                                }
                              }
                            }}
                          />
                        </th>

                        <Th
                          label="Cód. End."
                          value="codendereco"
                        />

                        <Th
                          label="Dep."
                          value="deposito"
                        />

                        <Th
                          label="Rua"
                          value="rua"
                        />

                        <Th
                          label="Prédio"
                          value="predio"
                        />

                        <Th
                          label="Nível"
                          value="nivel"
                        />

                        <Th
                          label="Apto"
                          value="apto"
                        />

                        <Th
                          label="Tipo End."
                          value="tipoender"
                        />

                        <Th label="SKU" />

                        <th>Bloqueio</th>
                        <th>Situação</th>

                        <Th
                          label="Status"
                          value="status"
                        />
                      </tr>
                    </thead>
                    <tbody>
                      {filteredAddresses.map((address) => (
                        <tr key={address.id}>
                          <td>
                            <Form.Check
                              disabled={
                                address.qtbloqueada ||
                                address.qtpendentrada ||
                                address.qtpendsaida ||
                                !address.codendereco
                              }
                              checked={
                                selectedAddresses.findIndex(
                                  (addr) => addr.id === address.id,
                                ) === -1
                                  ? false
                                  : true
                              }
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setSelectedAddresses((prevState) => [
                                    ...prevState,
                                    address,
                                  ])
                                } else {
                                  setSelectedAddresses((prevState) =>
                                    prevState.filter(
                                      (addr) => addr.id !== address.id,
                                    ),
                                  )
                                }
                              }}
                            />
                          </td>
                          <td>{getValue(address.codendereco)}</td>
                          <td>{getValue(address.deposito)}</td>
                          <td>{getValue(address.rua)}</td>
                          <td>{getValue(address.predio)}</td>
                          <td>{getValue(address.nivel)}</td>
                          <td>{getValue(address.apto)}</td>
                          <td>{getValue(address.tipoender)}</td>
                          <td>{getValue(address.sku)}</td>
                          <td>{getValue(address.bloqueio)}</td>
                          <td>{getValue(address.situacao)}</td>
                          <td>
                            <OverlayTrigger
                              overlay={
                                <Tooltip>
                                  {getCondition(address, 'text')}
                                </Tooltip>
                              }
                            >
                              <Square color={getCondition(address, 'color')} />
                            </OverlayTrigger>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>

                  <Paginate />
                </>
              )}
            </LoaderWMS>
          </Ghost>
        </ComponentContent>
      </ComponentContainer>

      {isModalProdutosOpen && (
        <ModalProdutos
          isOpen={isModalProdutosOpen}
          onClose={() => setIsModalProdutosOpen(false)}
          onSelectProducts={handleSelectProducts}
        />
      )}
    </>
  )
}
